import { useDebounceCallback } from '@react-hook/debounce';
import { useState } from 'react';

import { generateWordsFromSearch } from '../utils';

interface IUseDebouncedSearchArgs {
  wait?: number;
  leading?: boolean;
}

export function useDebouncedSearch(args?: IUseDebouncedSearchArgs) {
  const wait = typeof args?.wait === 'number' ? args.wait : 300;

  const [searchText, setSearchText] = useState<string | null>('');
  const [searchWords, setSearchWords] = useState<string[]>([]);

  const debouncedSetSearchWords = useDebounceCallback((value: string | null) => {
    const nextSearchWords = generateWordsFromSearch(value);

    setSearchWords(nextSearchWords);
  }, wait, args?.leading);

  const onSearch = (value: string | null) => {
    setSearchText(value || '');
    debouncedSetSearchWords(value);
  };

  return { searchText, searchWords, onSearch };
}
